import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    bgColor: "0CB744",
    textColor: "0CB744",
};

const theamSlice = createSlice({
    name: "theam",
    initialState,
    reducers: {
        storetheam: (state, action) => {
            return { ...state, ...action.payload };
        }
    }
});

export const { storetheam } = theamSlice.actions;
export default theamSlice.reducer;
